import React from "react";

/**
 * StatusChip — chip signature WYVIO.
 * Un point coloré + label uppercase 10.5px tracking-widest.
 * Palette monochrome + rouge doux pour bloqué + lime EXCLUSIVEMENT pour "urgent".
 */
const STATUS = {
  encours: { label: "En cours", dot: "#151515", bg: "#F2F2EE", text: "#151515" },
  bloque:  { label: "Bloqué",  dot: "#B7292E", bg: "#F4EEED", text: "#B7292E" },
  livre:   { label: "Livré",   dot: "#6B6B67", bg: "#F2F2EE", text: "#6B6B67" },
  prep:    { label: "En prép.", dot: "#8A8A80", bg: "#F2F2EE", text: "#8A8A80" },
  urgent:  { label: "Urgent",  dot: "#C8FF2F", bg: "#151515", text: "#FFFFFF" },
};

export function StatusChip({ status = "encours", label, testid, className = "" }) {
  const s = STATUS[status] || STATUS.encours;
  return (
    <span
      data-testid={testid}
      className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1.5 text-[10.5px] font-medium uppercase tracking-[0.16em] ${className}`}
      style={{ background: s.bg, color: s.text }}
    >
      <span
        aria-hidden
        className="inline-block h-1.5 w-1.5 rounded-full"
        style={{ background: s.dot }}
      />
      {label || s.label}
    </span>
  );
}
